module.exports = __webpack_public_path__ + "static/img/activity_h.8ee581b8.png";